import axios from "../reducers/authinterceptor";
import AuthHeader from "./auth.header";

const setHomepageContent = async (values) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/content/homepage",
    values,
    { headers: AuthHeader.authHeader() });
  return response.data;
};

const setUserSubsite = async (userId, subsiteId, sendEmail = true) => {
  console.log("adding user", userId, " to subsite ", subsiteId);
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/subsite/adduser",
    {
      "userId": userId,
      "subsiteId": subsiteId,
      "sendEmail": sendEmail
    },
    { headers: AuthHeader.authHeader() });
  return response.data;
};

const removeUserFromSubsite = async (userId, subsiteId) => {
  console.log("removing user", userId, " from subsite ", subsiteId);
  const response = await axios.delete(
    process.env.REACT_APP_API_URL + "/admin/subsite/removeuser/" + userId + "/" + subsiteId,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const updateSiteDown = async (siteDownText) => {
  var response = await axios
    .post(process.env.REACT_APP_API_URL + "/admin/subsite/siteDown",
      { "content": siteDownText }, { headers: AuthHeader.authHeader() });
  return response.data;
};

const getHomepageContent = async () => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/content/homepage", { headers: AuthHeader.authHeader() });
  console.log(response.data.data.homepage);
  return response.data.data;
};

const loadRetailSubsite = async (code) => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/subsite/" + code);
  return response.data;
};

const updateShipping = async (subsiteId, shippingData) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/subsite/shipping",
    {
      "shippingData": shippingData,
      "subsiteId": subsiteId
    },
    { headers: AuthHeader.authHeader() });
  return response.data;
};

const getSubsiteShipping = async (details) => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/subsite/shipping",
      { headers: AuthHeader.authHeader() });
  return response.data;
};

const toggleSubsiteStatus = async (value) => {
  var val = value ? "on" : "off";
  var response = await axios.get(process.env.REACT_APP_API_URL + "/admin/subsite/" + val,
    { headers: AuthHeader.authHeader() });
  return response.data;
};

const getAllSubsites = async () => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/allsubsites",
      { headers: AuthHeader.authHeader() });
  return response.data;
};

const getSubsiteById = async (id) => {
  const response = await axios.get(
    process.env.REACT_APP_API_URL + "/admin/subsites/" + id,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const setSubsiteActiveById = async (id, active) => {
  const response = await axios.put(
    process.env.REACT_APP_API_URL + "/admin/subsites/" + id + "/active",
    { active },
    { headers: AuthHeader.authHeader() }
  );
  return response.data.data;
};

const addEditSubsite = async (subsite) => {
  console.log("SUBSITE", subsite);
  const data = new FormData();

  data.append('logo', subsite.uploadedImage[0]);
  data.append('subsitename', subsite.subsitename);
  data.append('code', subsite.code);
  data.append('poc', subsite.poc);
  data.append('paymenttype', subsite.paymenttype);
  data.append('id', subsite.id);
  data.append('newDayLimit', subsite.newDayLimit);
  data.append('requireNewHireKit', !!subsite.requireNewHireKit);
  data.append('newHireKitDeadlineDays', subsite.newHireKitDeadlineDays || '');
  data.append('showFeaturedPage', subsite.showFeaturedPage !== false && subsite.showFeaturedPage !== 0);
  data.append('maxOrdersPerBalance', subsite.maxOrdersPerBalance || '');
  data.append('copySubsiteId', subsite.copySubsiteId);
  data.append('copyLogos', subsite.copyLogos);
  data.append('markNewNot', subsite.markNotNew);
  data.append('company', subsite.company);
  data.append('shipToSelf', subsite.shipToSelf);

  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/subsite/addedit", data,
    {
      headers: {
        ...AuthHeader.authHeader(),
        'Content-Type': 'multipart/form-data'
      }
    });

  console.log("RESPONSE", response);
  return response.data;

};

const getSubsitePriceCalculation = async () => {
  var response = await axios.get(process.env.REACT_APP_API_URL + "/admin/subsite/pricecalculation", { headers: AuthHeader.authHeader() });
  return response.data;
};

const calculatePriceForStyle = async (styleCode) => {
  var response = await axios.get(
    process.env.REACT_APP_API_URL + "/admin/subsite/pricecalculator?styleCode=" + encodeURIComponent(styleCode),
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};


const updateSubsitePriceCalculation = async (priceCalculation) => {
  var response = await axios.post(process.env.REACT_APP_API_URL + "/admin/subsite/pricecalculation", priceCalculation, { headers: AuthHeader.authHeader() });
  return response.data;
};

const setSubsite = async (subsite) => {
  var response = await axios.post(process.env.REACT_APP_API_URL + "/subsite/setsubsite", {subsiteId: subsite.id}, { headers: AuthHeader.authHeader() });
  return response.data;
};


const getSubsiteAddresses = async (subsiteId) => {
  const url = subsiteId
    ? process.env.REACT_APP_API_URL + "/admin/subsite/" + subsiteId + "/addresses"
    : process.env.REACT_APP_API_URL + "/admin/subsite/addresses";
  var response = await axios.get(url, { headers: AuthHeader.authHeader() });
  return response.data;
};

const addEditSubsiteAddress = async (address, subsiteId) => {
  const url = subsiteId
    ? process.env.REACT_APP_API_URL + "/admin/subsite/" + subsiteId + "/address"
    : process.env.REACT_APP_API_URL + "/admin/subsite/address";
  var response = await axios.post(url, address, { headers: AuthHeader.authHeader() });
  return response.data;
};

const deleteSubsiteAddress = async (addressId, subsiteId) => {
  const url = subsiteId
    ? process.env.REACT_APP_API_URL + "/admin/subsite/" + subsiteId + "/address/" + addressId
    : process.env.REACT_APP_API_URL + "/admin/subsite/address/" + addressId;
  var response = await axios.delete(url, { headers: AuthHeader.authHeader() });
  return response.data;
};

const getSubsiteNotes = async (subsiteId) => {
  const response = await axios.get(
    process.env.REACT_APP_API_URL + "/admin/subsite/" + subsiteId + "/notes",
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const addSubsiteNote = async (subsiteId, note) => {
  const response = await axios.post(
    process.env.REACT_APP_API_URL + "/admin/subsite/" + subsiteId + "/notes",
    { note: note },
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const deleteSubsiteNote = async (noteId) => {
  const response = await axios.delete(
    process.env.REACT_APP_API_URL + "/admin/subsite/notes/" + noteId,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const getSuperAdmins = async () => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/superadmins",
    { headers: AuthHeader.authHeader() });
  return response.data;
};

const addSuperAdmin = async (userId) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/superadmins/add",
    { userId },
    { headers: AuthHeader.authHeader() });
  return response.data;
};

const removeSuperAdminRole = async (userId) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/superadmins/remove",
    { userId },
    { headers: AuthHeader.authHeader() });
  return response.data;
};

const addSuperAdminToSubsite = async (userId, subsiteId) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/superadmins/add-to-subsite",
    { userId, subsiteId },
    { headers: AuthHeader.authHeader() });
  return response.data;
};

const SubsiteService = {
  setHomepageContent,
  getHomepageContent,
  setUserSubsite,
  removeUserFromSubsite,
  loadRetailSubsite,
  updateShipping,
  getSubsiteShipping,
  getAllSubsites,
  getSubsiteById,
  setSubsiteActiveById,
  toggleSubsiteStatus,
  updateSiteDown,
  addEditSubsite,
  getSubsitePriceCalculation,
  updateSubsitePriceCalculation,
  calculatePriceForStyle,
  setSubsite,
  getSubsiteAddresses,
  addEditSubsiteAddress,
  deleteSubsiteAddress,
  getSubsiteNotes,
  addSubsiteNote,
  deleteSubsiteNote,
  getSuperAdmins,
  addSuperAdmin,
  removeSuperAdminRole,
  addSuperAdminToSubsite
};

export default SubsiteService;